/**
 * A rota `/funil/gerenciar` (história 11.2) — "Gerenciar funis e etapas".
 *
 * **A casa definitiva do CRUD de Funis e Etapas é o Funil** (EXPERIENCE.md, Information
 * Architecture): ele saiu da antiga Administração e mora aqui, aberto pelo botão da tela do Funil.
 * O conteúdo é o cartão `FunisEEtapas`, redesenhado na 11.4 (cor por etapa e criação do funil
 * com várias etapas de uma vez).
 *
 * **Não é item de menu** (é tela filha do Funil) e por isso o caminho não mora em `CAMINHOS`. A rota
 * existe para todos os perfis: o botão só aparece para escopo `todas`, mas quem digitar o caminho
 * encontra a tela e é recusado pelo **serviço** nas escritas, como sempre foi com este cartão.
 */

import { Link, createRoute } from '@tanstack/react-router'

import { FunisEEtapas } from '@/modulos/negocios/FunisEEtapas'
import { useDefinirTitulo } from '@/shell/Shell'
import { CAMINHOS, CAMINHO_DE_GERENCIAR_FUNIS, TITULO_DE_GERENCIAR_FUNIS } from '@/shell/navegacao'
import { rotaDaAplicacao } from './aplicacao'

function TelaDeGerenciarFunis() {
  useDefinirTitulo(TITULO_DE_GERENCIAR_FUNIS)

  return (
    <>
      <p className="gerenciar-funis__voltar">
        <Link to={CAMINHOS.funil}>← Voltar ao Funil</Link>
      </p>
      <FunisEEtapas />
    </>
  )
}

export const rotaDeGerenciarFunis = createRoute({
  getParentRoute: () => rotaDaAplicacao,
  path: CAMINHO_DE_GERENCIAR_FUNIS,
  component: TelaDeGerenciarFunis,
})
